"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Icon = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _index = require("../../styles/index.js");
var _index2 = require("../Icon/icons/IconCheckAlt/index.js");
var _index3 = require("../Icon/icons/IconExclamationCircle/index.js");
var _index4 = require("../Icon/icons/IconInformationAlt/index.js");
var _styledComponents = _interopRequireDefault(require("../../styled-components.js"));
var _excluded = ["colorSet", "iconAriaLabel"];
var getIconByColorSet = function getIconByColorSet(colorSet) {
  switch (colorSet) {
    case 'negative':
      {
        return _index3.IconExclamationCircle;
      }
    case 'warning':
      {
        return _index3.IconExclamationCircle;
      }
    case 'positive':
      {
        return _index2.IconCheckAlt;
      }
    default:
      {
        return _index4.IconInformationAlt;
      }
  }
};
var BannerIcon = function BannerIcon(_ref) {
  var colorSet = _ref.colorSet,
    iconAriaLabel = _ref.iconAriaLabel,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var Component = getIconByColorSet(colorSet);
  return Component ? /*#__PURE__*/_react["default"].createElement(Component, Object.assign({
    title: iconAriaLabel,
    "aria-label": iconAriaLabel,
    "aria-hidden": !iconAriaLabel
  }, props), undefined) : null;
};
var Icon = exports.Icon = (0, _styledComponents["default"])(BannerIcon).withConfig({
  displayName: "Icon",
  componentId: "sc-1mveit9-0"
})(["margin-inline-end:", ";"], (0, _index.cssSpacing)('tighter', '12px'));